import { render, staticRenderFns } from "./svg-phone.vue?vue&type=template&id=98c60cda&scoped=true&"
import script from "./svg-phone.vue?vue&type=script&lang=js&"
export * from "./svg-phone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98c60cda",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/geras/Documents/electros/magic-electros-crm/vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('98c60cda')) {
      api.createRecord('98c60cda', component.options)
    } else {
      api.reload('98c60cda', component.options)
    }
    module.hot.accept("./svg-phone.vue?vue&type=template&id=98c60cda&scoped=true&", function () {
      api.rerender('98c60cda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/vue/svg/svg-phone.vue"
export default component.exports